import React, { Component} from 'react'
import PageLayout from '../../../components/layouts/PageLayout'
import ContentBG from './ContentBG'
import ContentEN from './ContentEN'
import ContentRU from './ContentRU'
import { withNamespaces } from 'react-i18next'
import { getLang } from '../../../utils/translate'

class View extends Component {
	constructor(props) {
		super(props)
		const lang = getLang()
		switch(lang) {
			case 'bg': this.state = {
				content: <ContentBG />
			}
			break
			case 'en': this.state = {
				content: <ContentEN />
			}
			break
			case 'ru': this.state = {
				content: <ContentRU />
			}
			break
			default: this.state = {
				content: <ContentBG />
			}
		}
	}

	static getDerivedStateFromProps(nextProps, prevState){
		const lang = getLang()
		let content
		switch(lang) {
			case 'bg': content = {
				content: <ContentBG />
			}
			break
			case 'en': content = {
				content: <ContentEN />
			}
			break
			case 'ru': content = {
				content: <ContentRU />
			}
			break
			default:  content = {
				content: <ContentBG />
			}
		}
		return content
	}

	render() {
		const { content } = this.state
		return <PageLayout>
			<div className='c-content'>
				<div className='o-wrapper u-padding-vertical'>
					<div className='o-layout o-layout--center'>
						<div className='o-layout__item u-1/1'>
							{content}
						</div>
					</div>
				</div>
			</div>
		</PageLayout>
	}
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/AboutUs/components/View.js